var map = {
	"./anxiang/icon_dispose.png": "LJ39",
	"./default/icon_dispose.png": "dPWO",
	"./huarong/icon_dispose.png": "mxMT",
	"./master/icon_dispose.png": "txPq",
	"./shaodong/icon_dispose.png": "90Fn",
	"./taoyuan/icon_dispose.png": "Xe6T",
	"./yueyang/icon_dispose.png": "FofC",
	"./zhuzhou/icon_dispose.png": "L9dk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NZRV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/icon_dispose\.png$
// module id = NZRV
// module chunks = 1